//CSS
import "./main.css";
import "./style.css";
// Brand tokens (phase 5a). Variables are global; base styles apply only inside
// .brand-root, so nothing existing changes until a screen opts in.
import "./brand/tokens.css";

import React, {
  StrictMode,
  // useState
} from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { createRoot } from "react-dom/client";

import { ToastContainer } from "react-toastify";

import { HelmetProvider } from "react-helmet-async";

//Pages
// The rebuilt marketing site — its own shell, tokens and type.
import BrandShell from "./brand/site/Shell";
import BrandHome from "./brand/site/Home";
import { Properties } from "./Pages/Properties";
import { RCApp } from "./RcMain";
import { World } from "./Pages/World";

//Services
import UserService from "./services/UserService";

// Components
import RenderOnAnonymous from "./components/RenderOnAnonymous";
import RenderOnAuthenticated from "./components/RenderOnAuthenticated";
import { DataProvider } from "./components/DataContext";
import { VrShowcase } from "./Pages/VrShowcase";
import { GT } from "./Pages/GT";
import { AddNewSpace } from "./Pages/Add New Space";
// import { Header } from "./components/Header";
import { AgencyListing } from "./Pages/Agency Listing";
// import { NetworkListing } from "./Pages/Network Listing";
import { Customers } from "./Pages/Customers";
import { CustomerDetails } from "./Pages/CustomerDetails";
// import { AgentProfile } from "./Pages/AgentProfile";
import { ComingSoon } from "./components/ComingSoon";
import { PrivacyPolicy } from "./Pages/PrivacyPolicy";
import { TermsOfUse } from "./Pages/TermsOfUse";
import UserContextProvider from "./context/UserContextProvider";
import { ThemeProvider } from "./context/ThemeContext";
import Breadcrumbs from "./components/Breadcrumbs";
import Layout from "./Layout";
import { AddShortlist } from "./Pages/AddShortlist";
import { AddCustomer } from "./Pages/AddCustomer";
import AddClient from "./Pages/AddClient";
import MyClientsPage from "./Pages/MyClientsPage";
import AddProject from "./Pages/AddProject";
import ProjectList from "./Pages/ProjectList";
import AddAgent from "./Pages/AgentList/AddAgent";
import ClientHomePage from "./Pages/ClientHomePage";
// import ClientRootPage from "./Pages/ClientRootPage";
// import { Leads } from "./Pages/Leads";
import { ClientAnalytics } from "./Pages/ClientAnalytics";
import { ClientAnalyticsV2 } from "./Pages/ClientAnalyticsV2";
import { AnalyticsV3 } from "./Pages/AnalyticsV3";
import { GuidedRoomJoin } from "./Pages/GuidedRoomJoin";
import { GuidedRoomHost } from "./Pages/GuidedRoomHost";
import { GuidedRoomGuest } from "./Pages/GuidedRoomGuest";
import EmbedPage from "./Pages/EmbedPage";
import { Profile } from "./Pages/Profile";
import AgentHomePage from "./Pages/AgentHomePage";
import CustomerHomePage from "./Pages/CustomerHomePage";
import HomeRedirect from "./components/HomeRedirect";
import AgentList from "./Pages/AgentList";
import SystemAdmins from "./Pages/SystemAdmins";
import { Leads } from "./Pages/Leads";
import { AddLeadForm } from "./Pages/Leads/AddLeadForm";
import CustomerAgencySelect from "./Pages/CustomerAgencySelect";
import ProjectDetailsV3 from "./Pages/ProjectDetailsV3";
import LeadGatePreview from "./Pages/LeadGatePreview";
import PublishPreview from "./Pages/PublishPreview";
import { guidedTourEnabled } from "./utils/featureFlags";
// Side-effect import: attaches window.seedDemoSessions for DevTools-driven
// one-off seeding of demo VR sessions. Safe in production — function exists
// but is only useful when called manually by super_admin.
import "./utils/seedDemoSessions";
// import ScrollToTop from "./components/ScrollToTop";
// import OpenSkyVRRedirect from "./components/OpenSkyVRRedirect";

const Navigations = () => {
  console.log("indexrr", UserService.hasRole("agent"));

  return (
    <BrowserRouter>
      {/* <ScrollToTop /> */}
      {/* <div className=" h-screen max-w-screen-2xl flex items-center flex-col "> */}
      {/* {!UserService.isLoggedIn() && (
          <div className=" conatiner max-w-screen-2xl w-full bg-[#000524] ">
            <Header drawerOpen={true} />
          </div>
        )} */}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <RenderOnAnonymous />

      <RenderOnAuthenticated>
        <Routes>
          {/* <Route path="/" element={<LandingPage />} /> */}
          {/* <Route path="/" element={<Properties />} /> */}
          {/* The rebuilt marketing site (brand programme, Oct 2026). Lives at
              /next until it replaces the old landing page. Public — the path
              is registered in utils/publicRoutes, and BOTH auth gates read
              that one list. */}
          <Route path="/next" element={<BrandShell />}>
            <Route index element={<BrandHome />} />
          </Route>
          <Route path="/test/:projectId" element={<ProjectDetailsV3 />} />
          {/* Standalone demo harness for the Matterport lead gate (no backend). */}
          <Route path="/leadgate-preview" element={<LeadGatePreview />} />
          {/* Publish-on-your-website modal, seeded with the design handoff's
              sample project. Runs entirely offline — the embed endpoints 404
              until the backend lands. */}
          <Route path="/publish-preview" element={<PublishPreview />} />
          {/* Website embed — the page that loads inside a CUSTOMER'S site.
              Public and outside <Layout>: the visitor is anonymous, on someone
              else's domain, and the asset takes the whole viewport.
              Belongs on embed.openskyvr.com, NOT the app host — serving it from
              the main host would make the whole app frameable, which is the
              exact failure the separate host prevents (spec §6). */}
          <Route path="/e/:key" element={<EmbedPage />} />
          {/* ── Guided tour rooms ──────────────────────────────────────
              NOT MOUNTED IN PRODUCTION (utils/featureFlags.ts). Hiding the
              button that creates a room is not enough on its own: these four
              paths are public, and a link forwarded on WhatsApp outlives the
              button that made it. Unmounted, they fall through to the app's
              normal not-found handling instead of rendering half a room in
              front of a paying client.

              Delete the condition, not the routes, when guided tours ship. */}
          {guidedTourEnabled() && (
            <>
              {/* Guided tour join — public, served on visit.openskyvr.com.
                  ?g=<guest_token> switches to the family (no-OTP) screen.
                  Declared OUTSIDE <Layout> on purpose: this is a buyer-facing
                  page and must not carry the agent app's header or drawer. */}
              <Route path="/visit/:joinCode" element={<GuidedRoomJoin />} />
              {/* Family pass — the same page, entered by its own door.
                  `openskyvr.com/pass/<token>` reads far better in a forwarded
                  WhatsApp message than a `?g=` query string, and a pass holder
                  never needs the join code: the token identifies the room. */}
              <Route path="/pass/:passToken" element={<GuidedRoomJoin />} />
              {/* Host side of the same room. Staff-only (it sits inside
                  RenderOnAuthenticated with no bypass), and outside <Layout>
                  because the room takes the full viewport — the app header
                  would eat 64px the walkthrough needs. */}
              <Route path="/room/:roomId" element={<GuidedRoomHost />} />
              {/* Buyer side of the same room, entered from the join page once
                  the host admits. PUBLIC and outside <Layout> for the same two
                  reasons as /visit: a buyer has no Keycloak account, and the
                  room takes the full viewport. Separate from /room because the
                  two authorise differently — this page is driven entirely by
                  the participant credential. */}
              <Route path="/tour/:roomId" element={<GuidedRoomGuest />} />
            </>
          )}
{/* Routes for new Design */}

          <Route path="/" element={<Layout />}>
            {/* V3 — accessible to all authenticated roles, lives inside Layout for shared top nav */}
            <Route path="v3/:projectId" element={<ProjectDetailsV3 />} />
            {/* Public share-link viewer fallback.
                Each role block below also registers c/:slug/p/:projectSlug,
                but those only mount when their role check passes. Anonymous
                share-link viewers (no role) need a route that's always
                present. React Router matches the FIRST declared route, and
                since every role's version renders the same ProjectDetailsV3
                anyway, this is also fine to act as the shared canonical
                entry — V3's own useEffect handles public-viewer mode based
                on ?ref=. The auth gate in RenderOnAuthenticated is already
                bypassed for this exact path + ?ref= combination. */}
            <Route path="c/:slug/p/:projectSlug" element={<ProjectDetailsV3 />} />
            {/* Short share-link route — /s/<code> resolves the same public
                viewer via the code (frontend-only shortener, no backend). Auth
                gate bypassed for this path in RenderOnAuthenticated/Anonymous. */}
            <Route path="s/:code" element={<ProjectDetailsV3 />} />
            {/* <Route path="admin"> */}
            {UserService.hasRole("super_admin") && (
              <>
                <Route path="" element={<MyClientsPage />} />
                <Route path="add_client" element={<AddClient />} />
                <Route path="clients" element={<MyClientsPage />} />
                <Route
                  path="edit_project/:projectId"
                  element={<AddProject />}
                />
                <Route
                  path="add_project/:clientId"
                  element={<AddProject />}
                />
              </>
            )}
            {/* setAgencyId(res.project?.agency["id"]); */}
            {/* `${digitalTwin?.digital_twin?.meta_models[0]}/?projectId=${
      projectId || ""
    }${agencyId ? `&agencyId=${agencyId}` : ""}${
      clientManagerId ? `&aba_id=${clientManagerId}` : ""
    }${
      clientAdminId ? `&asa_id=${clientAdminId}` : ""
    }${
      agentId ? `&agentId=${agentId}` : ""
    }${customerId ? `&customerId=${customerId}` : ""}`; */}
            {/* Client Routes */}
            {(UserService.hasRole("agency_business_admin") ||
              UserService.hasRole("agency_system_admin")) && (
              <>
                <Route path="" element={<HomeRedirect />} />
                <Route path="c/:slug" element={<ClientHomePage />} />
                <Route path="c/:slug/p/library" element={<ProjectList />} />
                <Route path="c/:slug/p/:projectSlug" element={<ProjectDetailsV3 />} />
                <Route path="c/:slug/agents" element={<AgentList />} />
                <Route path="c/:slug/system-admins" element={<SystemAdmins />} />
                <Route path="c/:slug/leads" element={<Leads />} />
                <Route path="c/:slug/analytics" element={<AnalyticsV3 />} />
                <Route path="c/:slug/analytics_v3" element={<AnalyticsV3 />} />
                <Route path="c/:slug/profile" element={<Profile />} />
                <Route path="client" element={<ClientHomePage />} />
                {/* <Route index element={<ClientHomePage />} /> */}
                {/* </Route> */}
                <Route path="add_project" element={<AddProject />} />
                <Route
                  path="edit_project/:projectId"
                  element={<AddProject />}
                />
                <Route
                  path="add_project/:clientId"
                  element={<AddProject />}
                />

                <Route path="project_list" element={<ProjectList />} />
                <Route path="agent_list" element={<AgentList />} />
                <Route path="add_agent" element={<AddAgent />} />
                <Route path="analytics" element={<ClientAnalytics />} />
                <Route path="analytics_v2" element={<ClientAnalyticsV2 />} />
                <Route path="analytics_v3" element={<AnalyticsV3 />} />
                <Route path="leads" element={<Leads />} />
                <Route path="add_lead" element={<AddLeadForm />} />
                <Route path="edit_lead/:leadId" element={<AddLeadForm />} />
                <Route path="profile" element={<Profile />} />
              </>
            )}
            {/* ============ AGENT ROUTES ============ */}
            {UserService.hasRole("agent") && (
              <>
                <Route path="" element={<HomeRedirect />} />
                <Route path="c/:slug" element={<AgentHomePage />} />
                <Route path="c/:slug/p/library" element={<ProjectList />} />
                <Route path="c/:slug/p/:projectSlug" element={<ProjectDetailsV3 />} />
                <Route path="c/:slug/leads" element={<Leads />} />
                <Route path="c/:slug/analytics" element={<AnalyticsV3 />} />
                <Route path="c/:slug/analytics_v3" element={<AnalyticsV3 />} />
                <Route path="c/:slug/profile" element={<Profile />} />
                <Route path="project_list" element={<ProjectList />} />
                <Route path="leads" element={<Leads />} />
                <Route path="add_lead" element={<AddLeadForm />} />
                <Route path="edit_lead/:leadId" element={<AddLeadForm />} />
                <Route path="analytics" element={<ClientAnalytics />} />
                <Route path="analytics_v2" element={<ClientAnalyticsV2 />} />
                <Route path="analytics_v3" element={<AnalyticsV3 />} />
                <Route path="profile" element={<Profile />} />

                <Route
                  path="agency_list"
                  element={
                    <>
                      <Breadcrumbs />
                      <AgencyListing />
                    </>
                  }
                />
                <Route
                  path="customers"
                  element={
                    <>
                      <Breadcrumbs />
                      <Customers />
                    </>
                  }
                />
                <Route
                  path="customer_details"
                  element={
                    <>
                      <Breadcrumbs />
                      <CustomerDetails />
                    </>
                  }
                />
                <Route
                  path="add_shortlist"
                  element={
                    <>
                      <Breadcrumbs />
                      <AddShortlist />
                    </>
                  }
                />
                <Route
                  path="add_customer"
                  element={
                    <>
                      <Breadcrumbs />
                      <AddCustomer />
                    </>
                  }
                />
              </>
            )}
          
            {/* ============ CUSTOMER ROUTES ============ */}
            {UserService.hasRole("customer") && (
              <>
                <Route path="" element={<HomeRedirect />} />
                <Route path="agency-select" element={<CustomerAgencySelect />} />
                <Route path="c/:slug" element={<CustomerHomePage />} />
                <Route path="c/:slug/p/library" element={<ProjectList />} />
                <Route path="c/:slug/p/:projectSlug" element={<ProjectDetailsV3 />} />
                <Route path="c/:slug/analytics" element={<AnalyticsV3 />} />
                <Route path="c/:slug/profile" element={<Profile />} />
              </>
            )}
            {/*Agent Routes </Route> */}
            {/* {UserService.hasRole("agent") && (
              <Route
                path=""
                element={
                  <>
                    <Breadcrumbs />
                    <AgencyListing />
                  </>
                }
              />
            )}
            <Route
              path="agency_list"
              element={
                UserService.hasRole("agent") ? (
                  <>
                    <Breadcrumbs />
                    <AgencyListing />
                  </>
                ) : (
                  <div>"Not Allowed to Customer"</div>
                )
              }
            />
            <Route
              path="/customers"
              element={
                UserService.hasRole("agent") ? (
                  <>
                    <Breadcrumbs />
                    <Customers />
                  </>
                ) : (
                  <div>"Not Allowed to Customers"</div>
                )
              }
            />
            <Route
              path="/customer_details"
              element={
                UserService.hasRole("agent") ? (
                  <>
                    <Breadcrumbs />
                    <CustomerDetails />
                  </>
                ) : (
                  <div>"Not Allowed to Customers"</div>
                )
              }
            />
            {UserService.hasRole("agent") && (
              <Route
                path="/add_shortlist"
                element={
                  <>
                    <Breadcrumbs />
                    <AddShortlist />
                  </>
                }
              />
            )}
            {UserService.hasRole("agent") && (
              <Route
                path="/add_customer"
                element={
                  <>
                    <Breadcrumbs />
                    <AddCustomer />
                  </>
                }
              />
            )} */}
            {/* {UserService.hasRole("customer") && (
              <Route
                path=""
                element={
                  <>
                    <Breadcrumbs />
                    <PropertiesShortlist />
                  </>
                }
              />
            )} */}
            {/* {UserService.hasRole("agency_business_admin") && (
              <Route
                path=""
                element={
                  <>
                    <ClientHomePage />
                    <Route path="" element={<ClientRootPage />}>
                    <Route index element={<ClientHomePage />} />
                    </Route>
                  </>
                }
              />
            )} */}
            {/* <Route
              path=""
              element={
                UserService.hasRole("agent") ? (
                  <>
                    <Breadcrumbs />
                    <AgencyListing />
                  </>
                ) :
                (
                  <>
                    <Breadcrumbs />
                    <PropertiesShortlist />
                  </>
                ) 
                
              }
            /> */}
            {/* <Route
              path="property_details"
              element={
                (UserService.hasRole("agent") ||
                  UserService.hasRole("customer")) && (
                  <>
                    <Breadcrumbs />
                    <Details />
                  </>
                )
              }
            /> */}
            {/* <Route
              path="profile"
              element={
                UserService.hasRole("agent") ? (
                  <>
                    <Breadcrumbs />
                    <AgentProfile />
                  </>
                ) : UserService.hasRole("customer") ? (
                  <>
                    <Breadcrumbs />
                    <CustomerProfile />
                  </>
                ) : (
                  <div>"Not Allowed "</div>
                )
              }
            /> */}
            {/* <Route
              path="properties_shortlist"
              element={
                UserService.hasRole("customer") ? (
                  <>
                    <Breadcrumbs />
                    <PropertiesShortlist />
                  </>
                ) : (
                  <div>"Not Allowed to Agent"</div>
                )
              }
            />
            <Route
              path="/vr_tour"
              element={
                UserService.hasRole("customer") ? (
                  <VrTour />
                ) : (
                  <div>"Not Allowed to Agent"</div>
                )
              }
            />

            <Route
              path="relationship_manager"
              element={
                UserService.hasRole("customer") ? (
                  <>
                    <Breadcrumbs />
                    <MyAgent />
                  </>
                ) : (
                  <div>"Not Allowed to Agent"</div>
                )
              }
            />

            <Route
              path="join_vr_tour"
              element={
                UserService.hasRole("customer") ? (
                  <VrTour />
                ) : (
                  <div>"Not Allowed to Agent"</div>
                )
              }
            /> */}
            <Route path="virtual-tour" element={<World Comp={<RCApp />} />} />
            {/* <Route path="/details" element={<PrevDetails />} /> */}
            {/* <Route path="/apartment" element={<Apartment />} /> */}
            <Route path="gt" element={<GT />} />
            {/* <Route path="/world" element={ <World Comp={<RCApp/>}/>  } /> */}
            {/* <Route path="/properties" element={<Properties properties={properties} />} /> */}
            <Route path="properties" element={<Properties />} />
            {/* <Route path="/property_details" element={<PropertyDetails />} /> */}
            {/* <Route path="/virtual-tour" element={<VirtualTour />} /> */}
            <Route path="vr-showcase" element={<VrShowcase />} />
            <Route path="add-new-space" element={<AddNewSpace />} />
            <Route path="earnings" element={<ComingSoon />} />
            <Route
              path="vr_tour_list"
              element={
                <>
                  <Breadcrumbs />
                  <ComingSoon />
                </>
              }
            />
            {/* <Route path='/intro-page' element= { <IntroPage />} /> */}
            {/* <Route path='/contact-us' element={<Contact />} />
            <Route path='/product_features' element={<ProductFeature />} />
            <Route path='/sell' element={<SellWithUs />} />
            <Route path='/pricing' element={<Pricing />} /> */}
            {/* <Route
              path="*"
              element={
                UserService.hasRole("agent") ? (
                  <>
                    <Breadcrumbs />
                    <AgencyListing />
                  </>
                ) : (
                  <PropertiesShortlist />
                )
              }
            /> */}
            <Route
              path="*"
              element={
                UserService.hasRole("agency_business_admin") ? (
                  <ClientHomePage />
                ) : UserService.hasRole("agent") ? (
                  <>
                    <Breadcrumbs />
                    <AgencyListing />
                  </>
                ) : (
                  <MyClientsPage />
                )
              }
            />
            <Route path="privacy_policy" element={<PrivacyPolicy />} />
            <Route path="terms_and_conditions" element={<TermsOfUse />} />
          </Route>
        </Routes>
      </RenderOnAuthenticated>
      {/* </div> */}
    </BrowserRouter>
  );
};

// const NewNav = React.memo(Navigations)
// root.render(
//   <NewNav />
// );
// UserService.initKeycloak(root);

const renderApp = () =>
  createRoot(document.getElementById("content")).render(
    <ThemeProvider>
      <UserContextProvider>
        <StrictMode>
          <HelmetProvider>
            <DataProvider>
              <Navigations />
            </DataProvider>
          </HelmetProvider>
        </StrictMode>
      </UserContextProvider>
    </ThemeProvider>,
  );

UserService.initKeycloak(renderApp);
